// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../../Img/feedback__bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feedback_feedback__BiS56 {
	padding: 6.25rem 10.31rem;
	background: var(--grey-color, #fff9f8);
	display: flex;
	justify-content: space-between;
}

.Feedback_left__side__4Vce- {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1.88rem;
}

.Feedback_block__title__feFbY {
	margin-top: 1.3rem;
	color: var(--accent-color, #875b52);

	font-size: 1.625rem;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 2.4375rem */
	width: 29rem;
}

.Feedback_primary__btn__015Dh {
	border-radius: 0.5rem;
	background: var(--accent-color, #875b52);

	/* btn primary */
	box-shadow: -2px 4px 5px 0px rgba(148, 93, 60, 0.06);
	padding: 0.75rem 2.44rem;

	color: var(--text-color, #fff);
	text-align: center;

	/* text small semibold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */

	margin-top: 1.5rem;

	width: 13.4375rem;
}

.Feedback_checkbox__-vZcg {
	display: flex;
	gap: 0.3rem;
	color: var(--accent-color, #875b52);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.Feedback_form__Mqtxj {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.8rem;
}

.Feedback_underline__text__W1lon {
	text-decoration: underline;
}

@media (max-width: 1280px) {
	.Feedback_feedback__BiS56 {
		padding: 6.25rem 5rem;
	}
}

@media (max-width: 460px) {
	.Feedback_feedback__BiS56 {
		flex-direction: column;
		padding: 4.38rem 1.25rem;
		align-items: center;
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	}
	.Feedback_feedback__BiS56 img {
		display: none;
	}
	.Feedback_form__Mqtxj {
		border-radius: 0.5rem;
		background: var(--grey-color, #fff9f8);
		padding: 1.87rem 1.56rem;
		gap: 1rem;
	}
	.Feedback_block__title__feFbY {
		font-size: 1.5rem;
		font-style: normal;
		font-weight: 500;
		line-height: 130%; /* 1.95rem */
		text-align: center;
		width: 100%;
	}

	.Feedback_primary__btn__015Dh {
		width: 100%;
		margin-top: 4rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/Feedback/Feedback.module.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,sCAAsC;CACtC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;;CAEnC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,cAAc;CACjC,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,wCAAwC;;CAExC,gBAAgB;CAChB,oDAAoD;CACpD,wBAAwB;;CAExB,8BAA8B;CAC9B,kBAAkB;;CAElB,wBAAwB;CACxB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,kBAAkB;;CAElB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,yDAAwD;CACzD;CACA;EACC,aAAa;CACd;CACA;EACC,qBAAqB;EACrB,sCAAsC;EACtC,wBAAwB;EACxB,SAAS;CACV;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,kBAAkB;EAClB,WAAW;CACZ;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;AACD","sourcesContent":[".feedback {\n\tpadding: 6.25rem 10.31rem;\n\tbackground: var(--grey-color, #fff9f8);\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.left__side {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 1.88rem;\n}\n\n.block__title {\n\tmargin-top: 1.3rem;\n\tcolor: var(--accent-color, #875b52);\n\n\tfont-size: 1.625rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 2.4375rem */\n\twidth: 29rem;\n}\n\n.primary__btn {\n\tborder-radius: 0.5rem;\n\tbackground: var(--accent-color, #875b52);\n\n\t/* btn primary */\n\tbox-shadow: -2px 4px 5px 0px rgba(148, 93, 60, 0.06);\n\tpadding: 0.75rem 2.44rem;\n\n\tcolor: var(--text-color, #fff);\n\ttext-align: center;\n\n\t/* text small semibold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n\n\tmargin-top: 1.5rem;\n\n\twidth: 13.4375rem;\n}\n\n.checkbox {\n\tdisplay: flex;\n\tgap: 0.3rem;\n\tcolor: var(--accent-color, #875b52);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.form {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.8rem;\n}\n\n.underline__text {\n\ttext-decoration: underline;\n}\n\n@media (max-width: 1280px) {\n\t.feedback {\n\t\tpadding: 6.25rem 5rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.feedback {\n\t\tflex-direction: column;\n\t\tpadding: 4.38rem 1.25rem;\n\t\talign-items: center;\n\t\tbackground-image: url('./../../../Img/feedback__bg.png');\n\t}\n\t.feedback img {\n\t\tdisplay: none;\n\t}\n\t.form {\n\t\tborder-radius: 0.5rem;\n\t\tbackground: var(--grey-color, #fff9f8);\n\t\tpadding: 1.87rem 1.56rem;\n\t\tgap: 1rem;\n\t}\n\t.block__title {\n\t\tfont-size: 1.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 130%; /* 1.95rem */\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t}\n\n\t.primary__btn {\n\t\twidth: 100%;\n\t\tmargin-top: 4rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feedback": `Feedback_feedback__BiS56`,
	"left__side": `Feedback_left__side__4Vce-`,
	"block__title": `Feedback_block__title__feFbY`,
	"primary__btn": `Feedback_primary__btn__015Dh`,
	"checkbox": `Feedback_checkbox__-vZcg`,
	"form": `Feedback_form__Mqtxj`,
	"underline__text": `Feedback_underline__text__W1lon`
};
export default ___CSS_LOADER_EXPORT___;
